import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { CategoriasService } from '../services';

const initForm = { nome: '', tipo: 'despesa', icone: '📁', cor: '#64748b' };

export default function Categorias() {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(initForm);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState('');
  const [tab, setTab] = useState('despesa');

  const load = () => {
    setLoading(true);
    CategoriasService.listar().then(setCategorias).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const minhas = categorias.filter(c => c.usuario_id !== null);
  const padrao = categorias.filter(c => c.usuario_id === null);

  const openNew = () => { setEditing(null); setForm({ ...initForm, tipo: tab }); setErro(''); setModal(true); };
  const openEdit = (c) => { setEditing(c); setForm({ ...c }); setErro(''); setModal(true); };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setErro('');
    try {
      if (editing) await CategoriasService.atualizar(editing.id, form);
      else await CategoriasService.criar(form);
      setModal(false); load();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar');
    } finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Desativar esta categoria?')) return;
    try { await CategoriasService.excluir(id); load(); }
    catch (err) { alert(err.response?.data?.erro || 'Erro'); }
  };

  return (
    <Layout title="Categorias">
      <div className="flex-between mb-3">
        <div className="tabs" style={{ borderBottom: 'none', marginBottom: 0 }}>
          {['despesa', 'receita', 'ambos'].map(t => (
            <button key={t} className={`tab ${tab === t ? 'active' : ''}`} onClick={() => setTab(t)}>
              {t === 'despesa' ? '⬇️ Despesas' : t === 'receita' ? '⬆️ Receitas' : '🔄 Ambos'}
            </button>
          ))}
        </div>
        <button className="btn btn-primary" onClick={openNew}>+ Nova Categoria</button>
      </div>

      {loading ? (
        <div className="loading-wrap"><div className="spinner" /></div>
      ) : (
        <>
          {/* Minhas categorias */}
          {minhas.filter(c => c.tipo === tab || c.tipo === 'ambos').length > 0 && (
            <div className="card mb-3">
              <div className="card-header"><span className="card-title">Minhas Categorias</span></div>
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Categoria</th><th>Tipo</th><th></th></tr></thead>
                  <tbody>
                    {minhas.filter(c => c.tipo === tab || c.tipo === 'ambos').map(c => (
                      <tr key={c.id}>
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div style={{ width: 34, height: 34, borderRadius: 8, background: c.cor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>
                              {c.icone}
                            </div>
                            <span style={{ fontWeight: 500, fontSize: 13 }}>{c.nome}</span>
                          </div>
                        </td>
                        <td>
                          <span className={`badge ${c.tipo === 'receita' ? 'badge-success' : c.tipo === 'despesa' ? 'badge-danger' : 'badge-primary'}`}>
                            {c.tipo}
                          </span>
                        </td>
                        <td>
                          <div className="flex-gap gap-sm">
                            <button className="btn btn-ghost btn-sm" onClick={() => openEdit(c)}>✏️ Editar</button>
                            <button className="btn btn-ghost btn-sm" style={{ color: 'var(--danger)' }} onClick={() => handleDelete(c.id)}>🗑️</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Categorias padrão */}
          <div className="card">
            <div className="card-header"><span className="card-title">Categorias do Sistema</span></div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12, padding: 16 }}>
              {padrao.filter(c => c.tipo === tab || c.tipo === 'ambos').map(c => (
                <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px', borderRadius: 8, background: 'var(--gray-50)', border: '1px solid var(--gray-100)' }}>
                  <div style={{ width: 32, height: 32, borderRadius: 7, background: c.cor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, flexShrink: 0 }}>
                    {c.icone}
                  </div>
                  <span style={{ fontSize: 12, fontWeight: 500 }}>{c.nome}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal modal-sm">
            <div className="modal-header">
              <span className="modal-title">{editing ? 'Editar Categoria' : 'Nova Categoria'}</span>
              <button className="modal-close" onClick={() => setModal(false)}>×</button>
            </div>
            <form onSubmit={handleSave}>
              <div className="modal-body">
                {erro && <div className="alert alert-danger">{erro}</div>}
                <div className="form-group">
                  <label className="form-label">Nome *</label>
                  <input className="form-control" required value={form.nome}
                    onChange={e => setForm(p => ({ ...p, nome: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Tipo *</label>
                  <select className="form-control" value={form.tipo}
                    onChange={e => setForm(p => ({ ...p, tipo: e.target.value }))}>
                    <option value="despesa">Despesa</option>
                    <option value="receita">Receita</option>
                    <option value="ambos">Ambos</option>
                  </select>
                </div>
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Ícone (emoji)</label>
                    <input className="form-control" value={form.icone} maxLength={4}
                      onChange={e => setForm(p => ({ ...p, icone: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Cor</label>
                    <input type="color" className="form-control" value={form.cor}
                      style={{ height: 40, padding: 4 }}
                      onChange={e => setForm(p => ({ ...p, cor: e.target.value }))} />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-ghost" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}
